import React from 'react';
import { Box } from 'components/base';
import { CircularProgress } from 'components/atoms';
import { Choice } from '../../type/preview.type';
import { divider } from 'assets/colors';
import { useGetAttachmentQuery } from 'hooks/useGetAttachment';

export const ChoiceImagePreview: React.FC<{
  choice: Choice;
}> = ({ choice }) => {
  const { data: attachmentData, isLoading: isLoadingAttachment } =
    useGetAttachmentQuery(choice?.image?.id || '');
  if (isLoadingAttachment) {
    return <CircularProgress size={20} sx={{ marginLeft: '10px' }} />;
  }
  return (
    <>
      {choice?.image && (
        <Box
          width="150px"
          height="100px"
          mt={1}
          mb={1}
          border={`1px solid ${divider}`}
          borderRadius={2}
        >
          <img
            src={choice?.image?.id && attachmentData?.[choice?.image?.id]?.file}
            alt={choice?.image?.name}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </Box>
      )}
    </>
  );
};
